// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SubMenu, JoinOrg, SignOutLink } from './UserSubMenu.styles.js';
import OrgSelect from '../../common/OrgSelect';
import LinkList from '../../common/LinkList/index.js';

class UserSubMenu extends Component {
  static propTypes = {
    /**
     * List of Organizations the Authenticated user is associated to that when clicked sets current active organization
     */
    organizations: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        permissions: PropTypes.arrayOf(PropTypes.string),
        role: PropTypes.string,
        id: PropTypes.number.isRequired
      })
    ),

    type: PropTypes.oneOf(['supplier', 'admin']).isRequired,

    /**
     * Passed component that
     */

    joinOrganization: PropTypes.node,
    /**
     * Authenticated Users Currently active organization ID.
     */
    userCurrentOrganization: PropTypes.number,

    /**
     * Change handler to send back selected org so all places can be updated by parent/ancestor
     */

    organizationChange: PropTypes.func,

    /**
     * An array of link objects passed through.
     */

    subMenuLinks: PropTypes.arrayOf(PropTypes.node),

    /**
     * sign out link passed through
     */
    signOut: PropTypes.node
  };

  static defaultProps = {
    /** These comments will not be pulled into the Storybook info panels */
    organizations: [],
    joinOrganization: null,
    userCurrentOrganization: undefined,
    organizationChange: () => {},
    subMenuLinks: [],
    signOut: null
  };

  render() {
    const {
      subMenuLinks,
      organizations,
      userCurrentOrganization,
      organizationChange,
      joinOrganization,
      signOut,
      type
    } = this.props;

    return (
      <SubMenu>
        <LinkList links={subMenuLinks} type="stacked" />
        {organizations.length > 0 && type === 'supplier' ? (
          <OrgSelect
            organizations={organizations}
            userCurrentOrganization={userCurrentOrganization}
            iconRotation={0}
            organizationChange={organizationChange}
            showIcon
          />
        ) : null}
        <JoinOrg>{joinOrganization}</JoinOrg>
        <SignOutLink>{signOut}</SignOutLink>
      </SubMenu>
    );
  }
}

export default UserSubMenu;
